export const GET_ACCESS_TOKEN = 'GET_ACCESS_TOKEN';
export const GET_ACCESS_TOKEN_SUCCESS = 'GET_ACCESS_TOKEN_SUCCESS';
export const GET_ACCESS_TOKEN_ERROR = 'GET_ACCESS_TOKEN_ERROR';
export const REFRESH_ACCESS_TOKEN = 'REFRESH_ACCESS_TOKEN';
export const REFRESH_ACCESS_TOKEN_SUCCESS = 'REFRESH_ACCESS_TOKEN_SUCCESS';
export const REFRESH_ACCESS_TOKEN_ERROR = 'REFRESH_ACCESS_TOKEN_ERROR';
export const FORCER_REFRESH_ACCESS_TOKEN = 'FORCER_REFRESH_ACCESS_TOKEN';
export const REVOKE_ACCESS_TOKEN = 'REVOKE_ACCESS_TOKEN';
export const SET_USER = 'SET_USER';
export const CLEAR_USER = 'CLEAR_USER';

export const UPDATE_ID_TOKEN = 'UPDATE_ID_TOKEN';

export const FETCH_DATA_SOURCES = 'FETCH_DATA_SOURCES';
export const FETCH_DATA_SOURCES_SUCCESS = 'FETCH_DATA_SOURCES_SUCCESS';
export const FETCH_DATA_SOURCES_FAILED = 'FETCH_DATA_SOURCES_FAILED';

export const SAVE_DATA_SELECTED_ASSET = 'SAVE_DATA_SELECTED_ASSET';
